import { SxProps } from '@mui/system';
import { colorPalette } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const Container = styled.div`
  border-right: 1px solid ${colorPalette.neutralVariant90};
  width: 220px;
`;

export const NewReportSx: SxProps = {
  '&:hover': {
    backgroundColor: 'rgba(29, 75, 122, 0.08)',
  },
  cursor: 'pointer',
  padding: '8px 16px',
};
